import { takeLatest, call, put } from "redux-saga/effects";
import { createSlice } from "@reduxjs/toolkit";

import Api from "../utils/api";

function* fetchStaffSaga({ payload }) {
  try {
    const response = yield call(Api.get, "/users/findAllStaff", payload);
    yield put(setStaff(response.data.users));
  } catch (err) {
    console.error(err);
  }
}

function* fetchStudentsSaga({ payload: { classNo, roomNo } }) {
  try {
    const response = yield call(
      Api.get,
      `/users/findStudents?classNo=${classNo}&roomNo=${roomNo}`
    );
    yield put(setStudents(response.data.users));
  } catch (err) {
    console.error(err);
  }
}

function* generateResetPasswordCodeSaga({ payload: { id, role } }) {
  try {
    const response = yield call(Api.post, "/authen/resetPasswordByTeacher", {
      userId: id,
    });
    yield put(updateResetPasswordCode({ ...response.data, id, role }));
  } catch (err) {
    console.error(err);
  }
}

export function* watchGenCodePasswordSaga() {
  yield takeLatest(fetchStaff.type, fetchStaffSaga);
  yield takeLatest(fetchStudents.type, fetchStudentsSaga);
  yield takeLatest(
    generateResetPasswordCode.type,
    generateResetPasswordCodeSaga
  );
}

export const genCodePasswordSlice = createSlice({
  name: "genCodePassword",
  initialState: {
    staff: [],
    students: [],
  },
  reducers: {
    fetchStaff: () => {},
    fetchStudents: () => {},
    setStaff: (state, action) => {
      state.staff = action.payload;
    },
    setStudents: (state, action) => {
      state.students = action.payload;
    },
    generateResetPasswordCode: () => {},
    updateResetPasswordCode: (state, action) => {
      const { role, id, ...others } = action.payload;
      if (role === "staff") {
        state.staff = state.staff.reduce((memo, curr) => {
          if (curr.id === id) return [...memo, { ...curr, ...others }];
          else return [...memo, curr];
        }, []);
      } else if (role === "student") {
        state.students = state.students.reduce((memo, curr) => {
          if (curr.id === id) return [...memo, { ...curr, ...others }];
          else return [...memo, curr];
        }, []);
      }
    },
  },
});

export const {
  fetchStaff,
  fetchStudents,
  setStaff,
  setStudents,
  generateResetPasswordCode,
  updateResetPasswordCode,
} = genCodePasswordSlice.actions;

export default genCodePasswordSlice.reducer;
